"use client";

import React from 'react'
import HeaderDesktop from './desktop/HeaderDesktop'
import useResponsive from '../hooks/useResponsive'
import BlogHeader from './blog/mobile/BlogHeader';

const MainHeader = ({ backgroundVariant } = {}) => {
  const isMobile = useResponsive()

  if (isMobile === null) {
    // Avoid initial flash of both variants before hydration
    return null
  }

  if (isMobile) {
    return <BlogHeader/>
  }

  return <HeaderDesktop backgroundVariant={backgroundVariant} />
}

export default MainHeader
